// src/plugins/bugsnag.ts
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import BugsnagPerformance from "@bugsnag/browser-performance";
import { App } from "vue";

const bugSnagApiKey = "0709918e5e0ec2d8bfad9d6575186e3a";

function shouldIgnoreBugsnagEvent(event: any) {
  const errorClass = String(event?.errors?.[0]?.errorClass || "").toLowerCase();
  const errorMessage = String(event?.errors?.[0]?.errorMessage || "").toLowerCase();

  return (
    errorClass.includes("429") ||
    errorMessage.includes("you are being rate limited") ||
    errorMessage.includes("resizeobserver loop completed with undelivered notifications")
  );
}

export function initializeBugsnag(app: App) {
  if (bugSnagApiKey) {
    Bugsnag.start({
      apiKey: bugSnagApiKey,
      plugins: [new BugsnagPluginVue()],
      onError(event) {
        if (shouldIgnoreBugsnagEvent(event)) {
          return false;
        }

        return true;
      },
    });

    BugsnagPerformance.start({ apiKey: bugSnagApiKey });
    const bugsnagVue = Bugsnag.getPlugin("vue");
    if (bugsnagVue) {
      app.use(bugsnagVue);
    }
  }
}

export const addUserMetadata = (user: any) => {
  if (user) {
    Bugsnag.addMetadata("user", {
      email: user.email,
      userId: user.userId,
      role: user.role,
      user: user,
    });
  }
};
